import { USER } from "../constants";
import { instance } from "../../axios";

let getUsers = () => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_GET_ALL,
    });
    instance({
      method: "GET",
      url: "/user/users",
    })
      .then((results) => {
        dispatch({
          type: USER.USER_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getCenterUsers = (centerId) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/user/center/${centerId}`,
    })
      .then((results) => {
        dispatch({
          type: USER.USER_GET_ALL_SUCCESS,
          payload: {
            employees: results.data.employees,
            monitors: results.data.monitors,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let editUser = (id, userDetails) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_UPDATE,
    });
    return instance({
      method: "PUT",
      url: `/user/${id}`,
      data: userDetails,
    })
      .then((results) => {
        dispatch({
          type: USER.USER_UPDATE_SUCCESS,
          payload: results.data,
        });
        return {
          success: true,
          data: results.data,
        };
      })
      .catch((error) => {
        console.error("Error updating user:", error);
        dispatch({
          type: USER.USER_UPDATE_FAILURE,
          payload: error,
        });
        return {
          success: false,
          status: error?.response?.status,
          code: error?.response?.data?.code,
          message: error?.response?.data?.message || error?.message,
        };
      });
  };
};

let updateUser = ({ id, updates }) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_UPDATE,
    });
    return instance({
      method: "PUT",
      url: `user/update/${id}`,
      data: updates,
    })
      .then((results) => {
        dispatch({
          type: USER.USER_UPDATE_SUCCESS,
          payload: results.data,
        });
        return true;
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_UPDATE_FAILURE,
          payload: error,
        });
        return false;
      });
  };
};

let resetPassword = (id, password) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_RESET_PASSWORD,
    });
    return instance({
      method: "POST",
      url: `/user/${id}/reset-password`,
      ...(password ? { data: { password } } : {}),
    })
      .then((results) => {
        dispatch({
          type: USER.USER_RESET_PASSWORD_SUCCESS,
          payload: results.data,
        });
        return true;
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_RESET_PASSWORD_FAILURE,
          payload: error,
        });
        return false;
      });
  };
};

// Update user status (active/inactive)
let updateUserStatus = (id, status) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_UPDATE,
    });
    return instance({
      method: "PUT",
      url: `user/${id}/status`,
      data: { status },
    })
      .then((results) => {
        dispatch({
          type: USER.USER_UPDATE_SUCCESS,
          payload: results.data.user,
        });
        return true;
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_UPDATE_FAILURE,
          payload: error,
        });
        return false;
      });
  };
};

let setUserAction = (user) => {
  return (dispatch) => {
    dispatch({
      type: USER.SET_USER,
      payload: user,
    });
  };
};

let cleanUserAction = () => {
  return (dispatch) => {
    dispatch({
      type: USER.CLEAN_USER,
    });
  };
};

let changePassword = (id, newPassword) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_CHANGE_PASSWORD,
    });
    return instance({
      method: "PUT",
      url: `user/${id}/password`,
      data: { newPassword: newPassword },
    })
      .then((results) => {
        dispatch({
          type: USER.USER_CHANGE_PASSWORD_SUCCESS,
          payload: results.data,
        });
        return true;
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_CHANGE_PASSWORD_FAILURE,
          payload: error.message,
        });
        return false;
      });
  };
};

let createUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_CREATE,
    });
    return instance({
      method: "POST",
      url: "/user",
      data: user,
    })
      .then((results) => {
        dispatch({
          type: USER.USER_CREATE_SUCCESS,
          payload: results.data,
        });
        return {
          success: true,
          data: results.data,
        };
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_CREATE_FAILURE,
          payload: error,
        });
        return {
          success: false,
          status: error?.response?.status,
          code: error?.response?.data?.code,
          message: error?.response?.data?.message || error?.message,
        };
      });
  };
};

// Delete user by ID
let deleteUser = (id) => {
  return (dispatch) => {
    dispatch({
      type: USER.USER_DELETE,
    });
    return instance({
      method: "DELETE",
      url: `/user/${id}`,
    })
      .then((results) => {
        dispatch({
          type: USER.USER_DELETE_SUCCESS,
          payload: results.data,
        });
        return true;
      })
      .catch((error) => {
        dispatch({
          type: USER.USER_DELETE_FAILURE,
          payload: error,
        });
        return false;
      });
  };
};

export {
  setUserAction,
  cleanUserAction,
  getUsers,
  getCenterUsers,
  createUser,
  updateUser,
  editUser,
  changePassword,
  resetPassword,
  updateUserStatus,
  deleteUser,
};
